<template>
	<span class="severity-badge" :class="'severity-badge--' + severity">{{ _label }}</span>
</template>

<script>
/**
 * Compact coloured pill for fraud alarm severity. Kept deliberately small
 * so it can sit inline next to a title or within a table row.
 *
 * Variants: info | warn | critical.
 */
const LABELS = {
	info:     'Info',
	warn:     'Advarsel',
	critical: 'Kritisk'
};

export default {
	props: {
		severity: { type: String, required: true }
	},
	computed: {
		_label() { return LABELS[this.severity] || this.severity; }
	}
};
</script>

<style lang="scss" scoped>
.severity-badge {
	display: inline-block;
	padding: 3px 10px;
	border-radius: 10px;
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	line-height: 1.4;

	&--info     { background: #2d3748; color: #a0b3c7; }
	&--warn     { background: #d6a000; color: #ffffff; }
	&--critical { background: #f7223f; color: #ffffff; }
}
</style>
